/**
 * Implements functionality for buttons that the user can use to clear selected filters in faceted
 * search.
 */
(() => {
    let form = document.querySelector('.js-faceted-search-form');

    if (!form) {
        return;
    }

    function clearKeyword(button, name) {
        let input = form.querySelector("input[name='" + name + "']");

        if (!input) {
            return;
        }

        input.value = input.value
            .replaceAll(button.getAttribute('data-value'), '')
            .trim()
            .replaceAll('  ', ' ')
            .replaceAll('  ', ' ');
        form.dispatchEvent(new Event('input'));
    }

    function clearInput(button, name) {
        const value = button.getAttribute('data-value');

        if (!value) {
            return;
        }

        let input = form.querySelector(
            "input[name='" + name + "'][value='" + value + "']"
        );

        if (!input) {
            return;
        }

        if (['checkbox', 'radio'].includes(input.type)) {
            input.checked = false;
        } else if (['text'].includes(input.type)) {
            input.value = '';
        } else {
            return;
        }

        input.dispatchEvent(new Event('change'));
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function onClick(e) {
        // console.log('Button was pressed');
        e.preventDefault();

        let button = e.currentTarget.closest('.js-faceted-search-clear-button');

        const name = button.getAttribute('data-name');

        if (!name) {
            return;
        }

        if (name === faceted_search.text_query_name) {
            clearKeyword(button, name);
        } else {
            clearInput(button, name);
        }
        H_Tools?.search?.showResults();
    }

    function clearAll(e) {
        // console.log('Clear all button pressed...');

        e.preventDefault();

        document
            .querySelectorAll(
                '.js-faceted-search-filters input:is([type=checkbox], input[type=radio])'
            )
            .forEach((input) => {
                input.checked = false;
                input.dispatchEvent(new Event('change'));
            });

        document
            .querySelectorAll(
                '.js-faceted-search-text-field, .js-faceted-search-filters input:is([type=text])'
            )
            .forEach((input) => {
                input.value = '';
                input.dispatchEvent(new Event('input'));
            });

        form.dispatchEvent(new Event('input'));
        H_Tools?.search?.showResults();
    }

    function addListeners() {
        // "Clear all" listener
        document
            .querySelector('.js-faceted-search-clear-all-button')
            ?.addEventListener('click', clearAll);

        const buttons = document.querySelectorAll(
            '.js-faceted-search-clear-button'
        );

        if (!buttons.length) {
            return;
        }

        buttons.forEach((button) => {
            button.addEventListener('click', onClick);
        });
    }

    form.addEventListener('htmx:afterSettle', (e) => {
        addListeners();
    });

    addListeners();
})();
